import * as yup from "yup";

import { nameStatusSchemaShape } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";

export const schema = yup.object().shape(nameStatusSchemaShape);
